import { ORDER_SET_LIST_DATA } from './actionTypes'

export default function orderSetListData(payload) {
  return {
    type: ORDER_SET_LIST_DATA,
    payload,
  }
}
